//HERForm.jsx
import {
  Button,
  TextField,
  Box,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

const HERForm = ({
  token,
  setToken,
  endpointUrl,
  setEndpointUrl,
  batchId,
  setBatchId,
  onFetchNotifications,
  onFetchBatches,
  selectedBatchId,
  setSelectedBatchId,
  isAllBatches,
  setIsAllBatches,
}) => {

  const handleReset = () => {
    setToken("");
    setEndpointUrl("");
    setBatchId("");
    setIsAllBatches(true);
    setSelectedBatchId("");
    localStorage.removeItem("herEndpointUrl");
    localStorage.removeItem("herToken");
    localStorage.removeItem("herBatchId");
    window.location.reload();
  };

  const handleSubmit = () => {
    if (!token.trim()) {
      alert("Error: Token is required");
      return;
    }
    if (!endpointUrl.trim()) {
      alert("Error: Endpoint URL is required");
      return;
    }
    if (!isAllBatches && !batchId.trim()) {
      alert("Error: Batch ID is required");
      return;
    }

    if(isAllBatches) {
      setSelectedBatchId("");
      onFetchBatches();
    } else {
      onFetchNotifications();
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Endpoint URL*"
            value={endpointUrl}
            onChange={(e) => setEndpointUrl(e.target.value)}
            variant="outlined"
            fullWidth
            required
            placeholder="https://api.example.com"
            helperText="Base URL for the API endpoint"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="Authorization Token*"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            variant="outlined"
            fullWidth
            required
            type="text"
            placeholder="Bearer token"
            helperText="Authorization token for API access"
          />
        </Grid>

        <Grid item xs={12} sm={8}>
          <TextField
            label="Batch ID*"
            value={batchId}
            onChange={(e) => setBatchId((e.target.value).trim())}
            variant="outlined"
            fullWidth
            required={!isAllBatches}
            disabled={isAllBatches}
            placeholder="3c01dc82-d460-4d4f-bfd2-cd3b024b738a"
            helperText="Unique identifier for the HER batch"
          />
        </Grid>

        <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isAllBatches}
                onChange={(e) => setIsAllBatches(e.target.checked)}
                color="primary"
              />
            }
            label="All Batches"
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!token.trim() || !endpointUrl.trim() || (!isAllBatches && !batchId.trim())}
        >
          {isAllBatches ? "Fetch All Batches" : "Fetch HER Notifications"}
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          onClick={handleReset}
        >
          Reset Form
        </Button>
      </Box>
    </Box>
  );
};

export default HERForm;
